import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
    root: {
        marginTop: 30,
        fontSize: 9,
        color: "#878787",
    },
    textStar: {
        width: 12,
    },
    row: {
        flexDirection: "row",
        marginBottom: 5,
    },
});
